import { StoreState } from '@/store';
import { normalize } from '@/utils/normalizeString';
import { setPageErrorData } from '@/views/auth-failure/duck/actions';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { errorDictionaries } from './mulesoft-error-handler.dict';
import { ErrorRecord } from './mulesoft-error.interface';

@Injectable({
  providedIn: 'root',
})
export class MulesoftErrorHandlerService {

  constructor(
    private store: Store<StoreState>,
    private router: Router,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
      .pipe(
        tap((response: any) => this.errorHandler(req, response)),
        catchError((response) => {
          this.errorHandler(req, response);
          return throwError(response);
        }),
      );
  }

  errorHandler(req: HttpRequest<any>, response: any) {
    const body = response.body || {};
    let error: string | Record<string, any> = '';
    if (response.error) {
      error = response.error;
    }
    else if (body.error) {
      error = body.error;
    }
    else if (typeof body === 'string') {
      error = body;
    }

    if (response instanceof HttpErrorResponse) {
      // eslint-disable-next-line no-undef-init
      let type: 'JSON' | 'text' | undefined = undefined;

      if (response?.error?.type === 'application/json') {
        type = 'JSON';
      }
      else if (response?.error?.type === 'text/plain') {
        type = 'text';
      }

      if (typeof response.error === 'string') {
        this.errorIdentifierAndRedirecter(response.error, req, response);
      }
      else if (type) {
        this.parseErrorBlob(response, type).subscribe({
          next: (errorTextOrJson: any) => {
            this.errorIdentifierAndRedirecter(errorTextOrJson, req, response);
          },
        });
      }
      else if (response?.error.error) {
        this.errorIdentifierAndRedirecter(response?.error.error, req, response);
      }
    }
    else if (error) {
      this.errorIdentifierAndRedirecter(error, req, response);
    }
  }

  errorIdentifierAndRedirecter(error: string | Record<string, any>, req: HttpRequest<any>, response: any) {
    let errorText = '';
    if (typeof error === 'object') {
      errorText = error.error || errorText;
    }
    else if (typeof error === 'string') {
      errorText = error;
    }

    const mulesoftError = errorDictionaries.find(
      ({ description }) => cleanError(errorText) === cleanError(description),
    );

    if (mulesoftError) {

      const headersArr = req.headers.keys().map((key) => ({ key, value: req.headers.get(key) || '' }));

      const errorRecord: ErrorRecord = {
        timestamp: new Date(),
        request: {
          headers: headersArr.map(({ key }) => key),
          url: req.urlWithParams,
          method: req.method,
          body: req.body,
        },
        response: {
          error: {
            name: errorText,
            description: mulesoftError.event,
          },
          status: response.status,
          statusName: mulesoftError.statusTypeName,
        },
      };

      /*
      this.store.dispatch(setPageErrorData({
        errorType: 'Mulesoft',
        name: 'Hubo un error en la conexión',
        message: `La conexión al sistema no está funcionando. Por favor recarge la pagina.
        \n Si no se soluciona el problema, por favor contacte con un administrador del sistema.`,
        buttonAction: 'DOWNLOAD_ERROR_LOG',
        errorDetails: errorRecord,
      }));
      */

      // this.router.navigateByUrl('/auth-failure');
    }
  }

  parseErrorBlob(err: HttpErrorResponse, type: 'JSON' | 'text'): Observable<any> {
    const reader: FileReader = new FileReader();

    const obs = Observable.create((observer: any) => {
      reader.onloadend = () => {
        if (type === 'text') {
          observer.next(reader.result);
        }
        else if (type === 'JSON') {
          if (typeof reader.result === 'string') {
            observer.next(JSON.parse(reader.result));
          }
        }
        observer.complete();
      };
    });
    reader.readAsText(err.error);
    return obs;
  }
}

const cleanError = (text: string) => replaceChar(removeChar(normalize(text), '.'), '_', ' ').replace(/\s/g, '');
const removeChar = (text: string, characters: string) => text.split(characters).join('');
const replaceChar = (text: string, lookup: string, newChar: string) => text.split(lookup).join(newChar);
